
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";


const Image = (props) => {
    return (<img  {...props}  src={props.src || require(`assets/img/${props?.type=="user"? "user.jpg" : "placeholder.webp"}`) }/>)
    
}
export default Image